import classNames from "classnames";
import TextBox, { Button as TextBoxButton } from "devextreme-react/text-box";
import toString from "lodash/toString";
import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import buildEyeButtonOptions from "./buildEyeButtonOptions";
export const SIZES = {
    BUTTON_WIDTH: 36,
    BUTTON_HEIGHT: 36
};
function TextWidget({ className, onChange, label, mode, name, height, maxLength, textBoxRef, textColor, onEnterKey, showClearButton, readOnly, disabled, showPasswordEyeButton, inputAttr, fieldName, ...other }) {
    var _a;
    const handleChange = useCallback((e) => {
        e.event && onChange && onChange(e.value, fieldName);
    }, [onChange, fieldName]);
    const [resultMode, setResultMode] = useState(mode);
    useEffect(() => {
        setResultMode(mode);
    }, [mode]);
    const hasClearButton = onEnterKey && mode === "search" && showClearButton !== false;
    const passwordButton = useMemo(() => showPasswordEyeButton
        ? buildEyeButtonOptions(resultMode, () => {
            setResultMode(prev => (prev === "text" ? "password" : "text"));
        }, SIZES.BUTTON_WIDTH, SIZES.BUTTON_HEIGHT)
        : null, [resultMode, height]);
    const searchButton = useMemo(() => onEnterKey && mode === "search"
        ? {
            disabled,
            icon: "search",
            elementAttr: {
                class: "no-border bg-transparent position-absolute",
                style: `width: ${SIZES.BUTTON_WIDTH}px; height: ${SIZES.BUTTON_HEIGHT}px;` +
                    "top: -2px; left: -1px; z-index: 1;"
            },
            width: SIZES.BUTTON_WIDTH,
            height: SIZES.BUTTON_HEIGHT,
            onClick() {
                onEnterKey && onEnterKey();
            }
        }
        : null, [onEnterKey, disabled, mode]);
    const hasRightButtons = Boolean(hasClearButton || passwordButton || ((_a = other.buttons) === null || _a === void 0 ? void 0 : _a.length));
    const resultInputAttr = useMemo(() => {
        const result = {
            ...(inputAttr || {}),
            style: textColor ? `color:${textColor};` : ""
        };
        if (height) {
            result.style += `height:auto;padding-top:2px;padding-bottom:2px;line-height:${parseInt(toString(height)) - 2 * (passwordButton ? 3 : 2)}px;`;
            result.class = classNames(result.class, "dx-placeholder-inherit");
        }
        if (hasRightButtons) {
            result.style += "padding-right:0;";
        }
        return result;
    }, [height, hasRightButtons, textColor, inputAttr]);
    return (React.createElement(TextBox, { defaultValue: "", inputAttr: resultInputAttr, className: classNames("w-100", className, textColor), label: label, onValueChanged: handleChange, valueChangeEvent: "input", mode: resultMode, ref: textBoxRef, name: name, height: height, spellcheck: false, maxLength: maxLength, showClearButton: showClearButton, onEnterKey: onEnterKey, readOnly: readOnly, disabled: disabled, labelMode: "floating", ...other },
        hasClearButton && React.createElement(TextBoxButton, { name: "clear" }),
        searchButton && (React.createElement(TextBoxButton, { name: "search-button", location: "before", options: searchButton })),
        passwordButton && (React.createElement(TextBoxButton, { name: "eye-button", location: "after", options: passwordButton })),
        other.children));
}
export default memo(TextWidget);
TextWidget.defaultProps = {
    placeholder: "",
    mode: "text",
    removeButton: false,
    maxLength: 250
};
